import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {


  upperCaseArray = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  lowerCaseArray = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

  numbersArray = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  constructor() { }

  public generatePassword() {
    let password = '';
    let upperLowerNumbersArray = [];
    let temp;
    for (var i=0; i<16; i++) {
      upperLowerNumbersArray = (this.upperCaseArray.concat(this.lowerCaseArray)).concat(this.numbersArray); 
      temp = Math.floor(Math.random()*upperLowerNumbersArray.length);
      password += upperLowerNumbersArray[temp]; 
    }
    return password;
  }
}
